import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, timer, forkJoin, BehaviorSubject, combineLatest, of } from 'rxjs';
import { filter, shareReplay, switchMap, tap } from 'rxjs/operators';
import { environment } from './../../../environments/environment';
import { AuthenticationService, LoginState } from './authentication.service';
import { LogCategory, LogCoreService, LoggerService, LogType } from './logger.service';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    //public notifications$: Observable<any> = null;
    private replaySubject$: ReplaySubject<any>;
    public polledNotifications$: Observable<any> = null;   
    private resetNotifications$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(
        private http: HttpClient,
        private logger: LoggerService,
        private auth: AuthenticationService,
    ) {
        this.log("constructor", null, LogCategory.Constructor);

        // Add this to the environment
        // environment.notificationPollingFrequency
        let NotificationPollingFrequency = 180000; //poll every 3 mins
        
        this.polledNotifications$ = combineLatest(this.resetNotifications$,auth.loginState$,timer(2000, NotificationPollingFrequency))
            .pipe(               
                switchMap(([notify, login, timer]) => {
                    if (((login >= LoginState.loggedin) && (login <= LoginState.spoofing_refreshable)))
                        return this.http.get<any>(environment.apiUrl + '/notifications')
                    else return of(null);
                }), //finite observables don't need to be unsubscribed
                tap((data) => { this.log("constructor", "Poll Notification", LogCategory.SubscriptionData); }),
                shareReplay()
        );
    }

    private deleteNotifcation$(notificationId: any): Observable<any> {
        return this.http.delete<any>(environment.apiUrl + '/notifications/' + notificationId)
    }

    public dismissNotification( notification: any ) {
        // Update spinning icon       
        notification.isBeingDismissed = true;
        this.deleteNotifcation$(notification.Id)
            .subscribe( //finite observables don't need to be unsubscribed
                () => { notification.isBeingDismissed = false; this.resetNotifications$.next(true)}
            );
    }

    public dismissAll(notifications: any[]) {
       
        //loop through list of notifications passed by browser click and call http delete for each
        let responses: any[] = [];
        notifications.forEach(
            item => (
                responses.push(
                    this.deleteNotifcation$(item.Id)
                )
            )
        );

        // ForkJoin gets values from completed observables and returns a completed observable with single value.
        // There's no need to unsubscribe from it.
        return forkJoin(responses)
            .subscribe(
                () => { this.resetNotifications$.next(true) }
            );
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.CoreService, LogCoreService.Alert, category);
    }
}
